import React from 'react';
import './app-loading.css';

function AppLoading() {
  return (
    <main className='dream-loading-main'>
      <img src='/dream-loading.svg' alt='Loading' width='44' height='48' />
    </main>
  );
}

export default AppLoading;
